import { render, staticRenderFns } from "./TwProcessDetailSimple.vue?vue&type=template&id=0cdbb73c&scoped=true&"
import script from "./TwProcessDetailSimple.vue?vue&type=script&lang=js&"
export * from "./TwProcessDetailSimple.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessDetailSimple.vue?vue&type=style&index=0&id=0cdbb73c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdbb73c",
  null
  
)

export default component.exports